module.exports = __webpack_public_path__ + "img/treatments-directory-card-mobile-ru.871b9648.jpg";